$(document).ready(function() {
  // Detect mobile screen size (for example, less than 768px)
  function checkScreenSize() {
    return $(window).width() < 768;
  }

  // Toggle the sidebar visibility for mobile only
  $(document).on('click', '.side-categories', function() {
    if (checkScreenSize()) {
      $('.sidebar').toggleClass('active'); // Toggling 'active' class on the sidebar
    }
  });

  // Ensure the sidebar is visible in desktop mode (when the screen is resized)
  $(window).resize(function() {
    if (!checkScreenSize()) {
      $('.sidebar').removeClass('active'); // Remove 'active' class on desktop
    }
  });
});

/* ------------------------------------------------------------------
   MyTuff4x4 kit builder (v4, 11 Oct 2026)
   Turns the APO dropdowns on Dobinsons lift kits into steps. APO still
   does the pricing and the add-to-cart: this only changes what the
   customer sees, by setting APO's own <select> elements. If anything
   here fails, the original dropdowns are left exactly as they were.
   v2: truck/load answers start blank and must be picked; extras start
   unticked; works on kits with or without a 2"/3" height choice.
   v3: pick-your-shocks step; SWB driveline / draglink / panhard advice.
   v4: runs on every Dobinsons lift kit (not a hand list); reads the
   dropdown labels more carefully (rear before front, engine before
   height, vehicle questions, stray "None" values ignored); more advice
   lines; generic wording for non-Toyota kits.
   v5 (12 Oct 2026): also runs on Tough Dog kits listed in INCLUDE; Tough Dog
   shock lines (Foam Cell / 40mm / 45mm); brake hose question in the truck step.
   v6 (12 Oct 2026): runs on every Tough Dog lift kit. Kits sold as Shopify variants
   (Shock Package / Spring Rating / struts ...) get the same steps: the builder reads
   the variants, puts the matching variant on the cart form and shows exact prices.
   On Tough Dog kits the "Dobinsons recommend" advice reads "We recommend".
   Buy with Shop (express checkout) waits for the questions too, like Add to cart.
   ------------------------------------------------------------------ */
(function () {
  "use strict";

  // Kits to leave alone even though they are Dobinsons lift kits (handles).
  var EXCLUDE = [];
  // Extra products to run on even though the title/vendor rule doesn't catch them (handles).
  var INCLUDE = ["tough-dog-3-suspension-lift-kit-suitable-for-105-series-toyota-landcruiser-1"];

  if (window.__mtKitBuilder) return;
  var m = location.pathname.match(/\/products\/([^\/?#]+)/);
  if (!m) {
    // Shopify's draft-product preview lives at /products_preview; the handle is in the canonical link.
    var canon = document.querySelector('link[rel="canonical"]') || document.querySelector('meta[property="og:url"]');
    m = canon ? String(canon.href || canon.content || "").match(/\/products\/([^\/?#]+)/) : null;
  }
  var HANDLE = m ? decodeURIComponent(m[1]) : "";
  if (!HANDLE) return;

  var basePrice = null;


  /* --- v6: Tough Dog kits sold as Shopify variants ------------------ */
  // The kit's own options (Shock Package, Spring Rating "front / rear", struts, ...)
  // become builder questions. Nothing on the page is re-rendered: the answers pick
  // the matching variant and only the cart form's variant id is changed.

  var PRODUCT = null;    // /products/{handle}.js
  var VG = null;         // variant-mode controller when the kit runs on variants

  function isToughDogKit() {
    if (EXCLUDE.indexOf(HANDLE) !== -1) return false;
    var p = metaProduct();
    var vendor = p && p.vendor ? String(p.vendor) : "";
    var title = pageTitle();
    return (/tough\s*dog/i.test(vendor) || /tough\s*dog/i.test(title)) && /lift\s*kit/i.test(title);
  }

  function uniq(a) {
    var out = [];
    a.forEach(function (x) { if (out.indexOf(x) === -1) out.push(x); });
    return out;
  }

  function isNotIncluded(v) { return /^(not included|no|none|no thanks)$/i.test(String(v).trim()); }

  // "Add to kit (2016+)" -> "Yes Please (2016+)"; "Return to centre" -> "Yes Please Return to centre"
  function addonLabel(v, optName) {
    var t = String(v).trim();
    if (isNotIncluded(t)) return "No Thanks";
    if (/^add to kit/i.test(t)) return t.replace(/^add to kit/i, "Yes Please");
    if (/^yes\b/i.test(t)) return t;
    if (t.toLowerCase() === String(optName).trim().toLowerCase() || /^pre-?assembled/i.test(t)) return "Yes Please";
    return "Yes Please " + t;
  }

  function kindFor(name, vals) {
    var n = String(name);
    if (/shock/i.test(n)) return "shock";
    if (vals.length >= 2 && vals.some(isNotIncluded)) return "addon";
    if (/^front\b.*(spring|coil)/i.test(n)) return "front";
    if (/^rear\b.*(spring|leaf|coil)/i.test(n)) return "rear";
    if (/engine|^model$/i.test(n)) return "engine";
    return "vehicle";
  }

  function productForm() {
    var s = document.querySelector("variant-selects select[form], variant-radios input[form]");
    var f = s ? document.getElementById(s.getAttribute("form")) : null;
    return f || document.querySelector('form[action*="/cart/add"]');
  }

  function variantPickers() {
    return Array.prototype.slice.call(document.querySelectorAll("variant-selects, variant-radios"));
  }

  function makeVariantGroups(p) {
    var opts = (p && p.options) || [];
    var V = ((p && p.variants) || []).map(function (v) { return { id: v.id, price: v.price / 100, o: (v.options || []).slice() }; });
    if (V.length < 2 || !opts.length) return null;
    function key(arr) { return arr.join("\u0001"); }
    var byKey = {};
    V.forEach(function (v) { byKey[key(v.o)] = v; });
    var base = V[0];
    V.forEach(function (v) { if (v.price < base.price) base = v; });

    // One question per option, except a "Front / Rear" spring rating, which becomes two.
    var parts = [];
    opts.forEach(function (o, oi) {
      var name = String(o.name || "");
      var vals = (o.values || []).map(String);
      var halves = null;
      if (vals.length > 1 && vals.every(function (x) { return x.split(" / ").length === 2; })) {
        var A = uniq(vals.map(function (x) { return x.split(" / ")[0]; }));
        var B = uniq(vals.map(function (x) { return x.split(" / ")[1]; }));
        if (A.length * B.length === vals.length) halves = [A, B];
      }
      if (halves && /spring/i.test(name)) {
        parts.push({ oi: oi, side: 0, name: "Front Spring Option", kind: "front", values: halves[0] });
        parts.push({ oi: oi, side: 1, name: "Rear Spring Option", kind: "rear", values: halves[1] });
      } else if (halves && halves[1].every(function (x) { return /hose/i.test(x); })) {
        parts.push({ oi: oi, side: 0, name: name, kind: "vehicle", values: halves[0] });
        parts.push({ oi: oi, side: 1, name: "Brake Hoses", kind: "vehicle", values: halves[1] });
      } else {
        var kind = kindFor(name, vals);
        var shown = (kind === "vehicle" && /brake/i.test(name) && !/brake hose/i.test(name)) ? "Brake Hoses" : name;
        parts.push({ oi: oi, side: -1, name: shown, kind: kind, values: vals });
      }
    });

    function baseVal(part) {
      var x = base.o[part.oi];
      return part.side < 0 ? x : x.split(" / ")[part.side];
    }
    function chosen(part) {
      if (!part.g) return part.values[0];
      var sel = part.g.sel;
      var v = part.g.values.filter(function (x) { return x.value === sel.value; })[0];
      return v ? v.real : null;
    }
    // The variant for the current answers; unanswered questions count as the base kit's answer.
    function variantFor(override) {
      var o = base.o.slice(), halves = {};
      parts.forEach(function (part, pi) {
        var val = (override && Object.prototype.hasOwnProperty.call(override, pi)) ? override[pi] : (chosen(part) || baseVal(part));
        if (part.side < 0) o[part.oi] = val;
        else {
          if (!halves[part.oi]) halves[part.oi] = base.o[part.oi].split(" / ");
          halves[part.oi][part.side] = val;
        }
      });
      Object.keys(halves).forEach(function (oi) { o[oi] = halves[oi].join(" / "); });
      return byKey[key(o)] || null;
    }

    var groups = [];
    parts.forEach(function (part, pi) {
      if (part.values.length < 2) return;                 // nothing to ask
      var sel = document.createElement("select");
      sel.id = "mtkbv" + pi;
      sel.appendChild(new Option("", ""));
      var values = part.values.map(function (val, j) {
        var lab = part.kind === "addon" ? addonLabel(val, part.name) : val;
        sel.appendChild(new Option(lab, "v" + j));
        return { value: "v" + j, raw: lab, label: lab, price: 0, real: val, virtual: true };
      });
      var g = { wrap: null, sel: sel, label: part.name, values: values, required: part.kind !== "addon", virtual: true, forceKind: part.kind };
      part.g = g;
      groups.push(g);
    });

    // Exact prices for the current answers: each value shows what it adds over the cheapest
    // value of the same question, with everything else as currently answered.
    function refresh() {
      parts.forEach(function (part, pi) {
        if (!part.g) return;
        var prices = part.g.values.map(function (v) {
          var ov = {}; ov[pi] = v.real;
          var hit = variantFor(ov);
          return hit ? hit.price : null;
        });
        var known = prices.filter(function (x) { return x != null; });
        var min = known.length ? Math.min.apply(null, known) : 0;
        part.g.values.forEach(function (v, j) {
          v.price = prices[j] == null ? 0 : Math.round((prices[j] - min) * 100) / 100;
          if (v.__amtEl) v.__amtEl.textContent = v.price ? "+" + money(v.price) : "Included";
          if (v.__opt) v.__opt.text = v.label + (v.price ? " (+" + money(v.price) + ")" : "");
          if (v.__chOpt) v.__chOpt.text = choiceLabel(v.label) + " — " + money(v.price);
        });
      });
    }
    function price() {
      var hit = variantFor(null);
      return hit ? hit.price : base.price;
    }
    // Put the matching variant on the cart form. No events, so nothing re-renders.
    function sync() {
      var hit = variantFor(null);
      var f = productForm();
      var idIn = f ? f.querySelector('[name="id"]') : null;
      if (hit && idIn && String(idIn.value) !== String(hit.id)) idIn.value = String(hit.id);
    }

    refresh();
    return { groups: groups, refresh: refresh, price: price, sync: sync, variantFor: variantFor };
  }

  // Where the builder goes when the kit has no APO options: just above the cart button.
  function addToCartAnchor() {
    var f = productForm();
    if (!f) return null;
    return f.querySelector(".product-form__buttons") || f.querySelector('[type="submit"], [name="add"]') || null;
  }

  // "yes" = APO options on the page, "none" = APO answered with no options, "wait" = not known yet.
  function apoState() {
    var c = document.querySelector(".mw-apo-container");
    if (c && c.querySelector(".mw-option select")) return "yes";
    try {
      var id = PRODUCT && PRODUCT.id ? "/" + PRODUCT.id + "/" : null;
      var es = performance.getEntriesByType("resource");
      for (var i = es.length - 1; id && i >= 0; i--) {
        if (es[i].name.indexOf("apo-admin.mageworx.com/front/product/") !== -1 && es[i].name.indexOf(id) !== -1 && es[i].responseStatus === 204) return "none";
      }
    } catch (e) {}
    return "wait";
  }

  function standDown(e) {
    if (window.__mtkbTeardown) { try { window.__mtkbTeardown(); } catch (x) {} }
    variantPickers().forEach(function (n) { n.classList.remove("mtkb-hidden"); });
    var c = document.querySelector(".mw-apo-container");
    if (c) c.classList.remove("mtkb-hidden");
    VG = null;
    if (window.console) console.log("[mtkb] stood down:", e);
  }

  // APO options that turn up after the builder went in without them: rebuild with them.
  function watchLateApo() {
    var n = 0;
    (function poll() {
      var c = document.querySelector(".mw-apo-container");
      if (c && c.querySelector(".mw-option select") && !c.classList.contains("mtkb-hidden")) {
        try {
          if (window.__mtkbTeardown) window.__mtkbTeardown();
          VG = makeVariantGroups(PRODUCT);
          if (!VG || !build(c, VG.groups, c)) throw new Error("rebuild failed");
        } catch (e) { standDown(e); }
        return;
      }
      if (++n < 40) setTimeout(poll, 500);
    })();
  }

  function metaProduct() {
    try { return window.ShopifyAnalytics.meta.product || null; } catch (e) { return null; }
  }
  // Fallback price when /products/{handle}.js is not available (draft-product preview).
  function metaPrice() {
    try {
      var p = metaProduct().variants[0].price;
      return p ? p / 100 : null;
    } catch (e) { return null; }
  }
  function pageTitle() {
    var h = document.querySelector(".product__title h1, .product__title, h1.product-title, h1");
    return ((h && h.textContent ? h.textContent : "") + " | " + (document.title || "")).trim();
  }
  // A Dobinsons lift kit? (vendor Dobinsons, or "Dobinsons" in the title) and "Lift Kit" in the title.
  function eligible() {
    if (EXCLUDE.indexOf(HANDLE) !== -1) return false;
    if (INCLUDE.indexOf(HANDLE) !== -1) return true;
    var p = metaProduct();
    var vendor = p && p.vendor ? String(p.vendor) : "";
    var title = pageTitle();
    var dob = /dobinson/i.test(vendor) || /dobinson/i.test(title);
    return dob && /lift\s*kit/i.test(title);
  }

  /* --- helpers --------------------------------------------------- */

  function money(n) {
    return "$" + Number(n).toLocaleString("en-AU", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  // The real charge is APO's own trailing "(+$X.XX AUD)". Anything earlier is hand-typed.
  function priceOf(text) {
    var r = String(text).match(/\(\+\s*\$([\d,]+(?:\.\d+)?)\s*AUD\s*\)\s*$/i);
    return r ? parseFloat(r[1].replace(/,/g, "")) : 0;
  }

  // Strip every "(+$...)" and any unclosed bracket left behind.
  function cleanLabel(text) {
    var t = String(text).replace(/\(\+\s*\$[\d,.]+\s*(AUD)?\s*\)?/gi, " ");
    var open = (t.match(/\(/g) || []).length, close = (t.match(/\)/g) || []).length;
    if (open !== close) t = t.replace(/[()]/g, " ");
    return t.replace(/\s{2,}/g, " ").trim();
  }

  // "Coil Spring Options:" -> "Coil Spring Options"
  function tidy(label) {
    return String(label).replace(/\s*[:\-–]\s*$/, "").replace(/\s{2,}/g, " ").trim();
  }

  // "Yes Please Spacer Style" -> "Spacer Style"; a bare "Yes Please" is left alone.
  function choiceLabel(lbl) {
    var t = String(lbl).replace(/^yes[,]?\s*(please)?\s*[-–:]?\s*/i, "").trim();
    return t || lbl;
  }

  // What a single "yes" answer adds beyond the option's own name, e.g.
  // "Yes Please (Blackhawk Arms)" under "Add Upper Control Arm Kit" -> "Blackhawk Arms".
  function extraDetail(valueLabel, optionLabel) {
    var t = String(valueLabel).replace(/^yes[,]?\s*(please)?\s*/i, "").trim();
    if (!t || /^yes\b/i.test(t)) return "";
    t = t.replace(/^add\s+/i, "");
    var opt = tidy(optionLabel).replace(/^add\s+/i, "").trim();
    if (opt && t.toLowerCase().indexOf(opt.toLowerCase()) === 0) t = t.slice(opt.length);
    t = t.replace(/\+?\s*\$\s*[\d,]+(\.\d+)?/g, " ");          // "+ $700.00" fragments
    t = t.replace(/[()]/g, " ");                                 // brackets (often unbalanced in the data)
    t = t.replace(/^[\s:\-\u2013]+|[\s:\-\u2013]+$/g, "");
    t = t.replace(/\s{2,}/g, " ").trim();
    if (!t || /^[\s()+.,\d]*$/.test(t)) return "";
    return t;
  }

  // "2 Inch", "2\"", "2″", "2'", "2.5 Inch Front:" -> 2 / 2.5 ; anything else -> null
  function heightOf(label) {
    var r = String(label).match(/^(\d+(?:\.\d+)?)\s*("|″|”|'|inch|in)?\s*(front|lift)?\s*:?$/i) || String(label).match(/^(\d+(?:\.\d+)?)\s*("|″|”|inch\b|in\b)\s*(front|lift)?\s*:?\s*[(\-–].*$/i); // v7 20 Oct 2026: also reads "3 Inch (Upper Control Arms Required)" as 3
    return r ? parseFloat(r[1]) : null;
  }

  // Set a native select so APO's own listeners fire.
  function setSelect(sel, value) {
    if (!sel || sel.value === value) return;
    var setter = Object.getOwnPropertyDescriptor(window.HTMLSelectElement.prototype, "value").set;
    setter.call(sel, value);
    sel.dispatchEvent(new Event("input", { bubbles: true }));
    sel.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  /* --- read the APO groups --------------------------------------- */

  function readGroups(container) {
    var out = [];
    container.querySelectorAll(".mw-option").forEach(function (w) {
      var sel = w.querySelector("select");
      if (!sel) return;
      var labNode = w.querySelector("label, .mw-option__label, .mw-option-title");
      var label = labNode ? labNode.textContent.replace(/\*/g, "").trim() : "";
      var values = [];
      Array.prototype.forEach.call(sel.options, function (o) {
        if (o.value === "") return;
        values.push({ value: o.value, raw: o.text, label: cleanLabel(o.text), price: priceOf(o.text) });
      });
      var required = w.classList.contains("mw-option--required");
      out.push({ wrap: w, sel: sel, label: label, values: values, required: required });
    });
    return out;
  }

  function isNo(v) { return /^no(\s*thanks)?\b|^none$/i.test(v.label); }
  function noThanksValue(g) {
    var n = g.values.filter(isNo)[0];
    return n ? n.value : null;
  }
  function yesValues(g) {
    return g.values.filter(function (v) { return !isNo(v); });
  }
  // One "No" plus only "Yes ..." answers: an add-on, whatever the label says.
  function strictYesNo(g) {
    var no = g.values.filter(isNo), yes = yesValues(g);
    return no.length >= 1 && yes.length >= 1 && yes.every(function (v) { return /^yes\b/i.test(v.label); });
  }

  function classify(g) {
    if (g.forceKind) return g.forceKind;
    var l = g.label.toLowerCase().trim();
    var heightLabel = /\d(\.\d)?\s*(-|or|to)\s*\d(\.\d)?\s*("|″|inch|in\b)/i.test(l) || /^\d\s*-\s*\d/.test(l);
    if (/engine/i.test(l)) return "engine";
    var numeric = g.values.filter(function (v) { return heightOf(v.label) !== null; });
    var allNumeric = numeric.length >= 2 && numeric.length === g.values.length;
    if (numeric.length >= 2 && (heightLabel || (allNumeric && /inch|lift|height|"|″/i.test(l)))) return "height";
    if (heightLabel) return "other";
    if (/^shocks?\b|shock absorber|shock option|which shock|shock choice/i.test(l)) return "shock";
    if (/brake hose/i.test(l) && !strictYesNo(g)) return "vehicle";
    if (/^(does|is|has)\b|wagon|cab chassis|year model|model year|^model\b|swb\s*\/\s*lwb|^swb\b|^lwb\b|wheelbase|kdss|my vehicle|door|vehicle selection|led headlight|mounting position/i.test(l)
        && !/spring|coil|kit\b|spacer|bracket|bush/i.test(l)) return "vehicle";
    var yn = strictYesNo(g);
    if (!yn && /rear/i.test(l) && /coil|spring|leaf|load|weight/i.test(l)) return "rear";
    if (!yn && /leaf spring|leaf option|spring options rear|rear load|constant load|^load\b/i.test(l)) return "rear";
    if (!yn && /coil|spring|what'?s on the front|front accessories|bar.*winch/i.test(l)) return "front";
    if (noThanksValue(g) && yesValues(g).length) return "addon";
    return "other";
  }

  /* --- advice, keyed off the group label ------------------------- */
  // g2 / g3 = how strongly we push it at 2 inch / 3 inch. Kits with no height choice use g2.

  var ADVICE = {
    front: "A bar and a winch put weight on the front. It decides which coil we send.",
    rear: "Constant load — what's in there most of the time, not the odd trip.",
    engine: "Some engines are heavier at the front, so we match the coil to it.",
    strut: { why: "Saves the workshop pulling your old struts apart. Bolt-in, ready to go.", g2: "opt", g3: "opt" },
    arms: {
      why2: "Pulls the caster back toward factory. Worth it if you carry weight or tow.",
      why3: "At 3 inch the alignment won't come back into spec without them.",
      g2: "rec", g3: "req"
    },
    pins: { why: "Greasable means they don't seize. Cheap now, a nightmare later.", g2: "rec", g3: "rec" },
    diff: {
      why2: "You can get away without one at 2 inch. It roughly doubles how long the CV boots last.",
      why3: "At 3 inch the CV angle is past what the factory allowed for. Fit one.",
      g2: "rec", g3: "req"
    },
    castor: { why: "Lifting the front changes the castor angle. Dobinsons recommend a wheel alignment to check whether you need these.", g2: "opt", g3: "opt" },
    damper: { why: "A heavy duty steering damper settles the front end over corrugations and with bigger tyres.", g2: "opt", g3: "opt" },
    sway: { why: "Puts the sway bar back at the right angle after the lift.", g2: "opt", g3: "opt" },
    driveline: { why: "A lift steepens the tailshaft angle on a short wheelbase. Dobinsons recommend this kit on every raised SWB to cut driveline vibration.", g2: "rec", g3: "rec" },
    draglink: { why: "An adjustable draglink lets us centre the steering wheel again after the lift.", g2: "opt", g3: "opt" },
    panhard: { why: "The lift pulls the axle slightly to one side. An adjustable panhard rod puts it back in the middle.", g2: "opt", g3: "opt" },
    tailshaft: { why: "For utes with a two-piece tailshaft. Drops the centre bearing to match the lift so it doesn't vibrate.", g2: "opt", g3: "opt" },
    headlight: { why: "Points the headlights back down after the lift.", g2: "opt", g3: "opt" },
    torsion: { why: "Heavy duty torsion bars to lift and firm up the front.", g2: "opt", g3: "opt" },
    brakelines: { why: "Longer lines and brackets so nothing is stretched tight at full droop.", g2: "opt", g3: "opt" },
    brakeadj: { why: "Resets the rear brake proportioning valve for the new ride height.", g2: "opt", g3: "opt" },
    resbracket: { why: "Mounts the remote reservoirs properly. Dobinsons recommend it with reservoir shocks.", g2: "rec", g3: "rec" },
    bushkit: { why: "New bushes while it's all apart.", g2: "opt", g3: "opt" },
    bjspacer: { why: "Takes the strain off the upper ball joint at the new ride height.", g2: "opt", g3: "opt" }
  };

  var ADVICE_BRAKE_HOSE = "Longer hoses so nothing is stretched at the new height. 3 hoses if your vehicle has ABS, 2 if it doesn't. Braided are tougher.";

  // Rear springs sold by rate (linear / variable / constant load) instead of by weight.
  var ADVICE_REAR_RATE = "Linear rate for an empty or lightly loaded wagon. Variable rate if the load changes trip to trip. Constant load if the weight is always in there.";

  // One line under each shock on the pick-your-shocks step.
  var SHOCK_WHY = [
    [/remote reservoir|\bmrr\b/i, "Extra oil in the remote reservoir. Stays firm when the shocks get hot — touring and towing."],
    [/adjustable|\bmra\b/i, "Three-way adjustable damping. Soft for daily driving, firm when the truck is loaded."],
    [/monotube|\bims\b/i, "Bigger bore monotube. Runs cooler on long corrugated roads."],
    [/nitro|\bgas\b|\bgs\b/i, "Twin tube, nitrogen charged. The everyday choice."]
  ];
  var SHOCK_WHY_TD = [
    [/foam cell.*front.*(9.?stage|adjustable)/i, "Foam cell up front, 9-stage adjustable at the back. Set the rear softer or firmer for the load."],
    [/foam cell.*front.*nitro/i, "Foam cell up front, nitro gas at the back. A good all-rounder for touring."],
    [/ralph|53 ?mm/i, "53mm big bore. Built for heavy loads and towing."],
    [/45\s*mm/i, "45mm big bore, 9-stage adjustable. Runs cooler under heavy touring and towing."],
    [/40\s*mm/i, "40mm bore, 9-stage adjustable. Turn the dial at the base for a softer or firmer ride."],
    [/foam cell/i, "Foam cell instead of gas, so it doesn't fade on long rough tracks. Fit and forget."],
    [/9.?stage|adjustable/i, "9-stage adjustable. Turn the dial at the base for a softer or firmer ride."],
    [/nitro/i, "Nitrogen gas charged. A solid everyday shock."]
  ];
  function shockWhy(label) {
    if (/tough\s*dog/i.test(pageTitle())) {
      for (var j = 0; j < SHOCK_WHY_TD.length; j++) if (SHOCK_WHY_TD[j][0].test(label)) return SHOCK_WHY_TD[j][1];
    }
    for (var i = 0; i < SHOCK_WHY.length; i++) if (SHOCK_WHY[i][0].test(label)) return SHOCK_WHY[i][1];
    return "";
  }

  function addonKey(label) {
    var l = label.toLowerCase();
    var rear = /\brear\b/.test(l);
    if (/ball joint/.test(l)) return "bjspacer";
    if (/cast(e|o)r/.test(l)) return rear ? null : "castor";
    if (/bush kit|shackle bush|bush$/.test(l)) return "bushkit";
    if (/strut/.test(l)) return "strut";
    if (/control arm|upper arm|lower arm/.test(l)) return rear ? null : "arms";
    if (/pins|shackle/.test(l)) return "pins";
    if (/diff drop/.test(l)) return "diff";
    if (/stabili[sz]er|steering damper/.test(l)) return "damper";
    if (/sway/.test(l)) return "sway";
    if (/driveline|drive line/.test(l)) return "driveline";
    if (/tail ?shaft/.test(l)) return "tailshaft";
    if (/drag ?link/.test(l)) return "draglink";
    if (/panhard/.test(l)) return "panhard";
    if (/headlight/.test(l)) return "headlight";
    if (/torsion/.test(l)) return "torsion";
    if (/brake adjuster/.test(l)) return "brakeadj";
    if (/brake line|\babs\b/.test(l)) return "brakelines";
    if (/reservoir/.test(l)) return "resbracket";
    return null;
  }

  /* --- build ------------------------------------------------------ */

  function build(container, extra, anchor) {
    // v6: extra = variant questions (listed first so they lead each step); anchor = where the
    // builder goes when there is no APO block (variant kits without APO options).
    var groups = (extra || []).concat(container ? readGroups(container) : []);
    if (!groups.length) return false;

    var height = null, shock = null, truck = [], addons = [], others = [];
    groups.forEach(function (g) {
      var kind = classify(g);
      if (kind === "height" && !height) height = g;
      else if (kind === "shock" && !shock && g.values.length) shock = g;
      else if (kind === "front" || kind === "rear" || kind === "engine" || kind === "vehicle") { g.kind = kind; truck.push(g); }
      else if (kind === "addon") addons.push(g);
      else others.push(g);
    });
    // front, engine, rear, then vehicle questions (stable sort)
    var order = { front: 0, engine: 1, rear: 2, vehicle: 3 };
    truck = truck.map(function (g, i) { return { g: g, i: i }; })
      .sort(function (a, b) { return (order[a.g.kind] - order[b.g.kind]) || (a.i - b.i); })
      .map(function (x) { return x.g; });
    var kindCount = {};
    truck.forEach(function (g) { kindCount[g.kind] = (kindCount[g.kind] || 0) + 1; });

    var steps = (height ? 1 : 0) + (shock ? 1 : 0) + (truck.length ? 1 : 0) + (addons.length ? 1 : 0);
    var stepNo = 0;
    function stepLabel() { stepNo++; return "Step " + stepNo + " of " + steps; }

    var root = el("div", "mtkb");
    var heightNow = null;
    var shockNow = null;   // the chosen shock value object (its price goes in the total)
    var truckSelects = [];

    /* height — only the numeric values are offered; a stray "None" is never selected */
    if (height) {
      var hvals = height.values.filter(function (v) { return heightOf(v.label) !== null; });
      var s1 = el("div", "mtkb__step");
      s1.appendChild(el("p", "mtkb__no", stepLabel()));
      s1.appendChild(el("h3", null, "How high are you going?"));
      s1.appendChild(el("p", "mtkb__hint", "This decides what else the truck needs. The extras below update when you change it."));
      var seg = el("div", "mtkb__seg");
      hvals.forEach(function (v) {
        var n = heightOf(v.label);
        var b = el("button", null, n + "\"");
        b.type = "button";
        b.setAttribute("aria-pressed", "false");
        b.addEventListener("click", function () {
          seg.querySelectorAll("button").forEach(function (x) { x.setAttribute("aria-pressed", "false"); });
          b.setAttribute("aria-pressed", "true");
          setSelect(height.sel, v.value);
          heightNow = n;
          renderAddons();
        });
        seg.appendChild(b);
      });
      s1.appendChild(seg);
      root.appendChild(s1);
      var firstBtn = seg.querySelector("button");
      if (firstBtn) { firstBtn.setAttribute("aria-pressed", "true"); setSelect(height.sel, hvals[0].value); heightNow = heightOf(hvals[0].label); }
    }

    /* shocks — cards. The one included shock starts selected; if several cost nothing extra, the customer picks. */
    var shockStep = null;
    if (shock) {
      var ss = el("div", "mtkb__step");
      shockStep = ss;
      var anyPriced = shock.values.some(function (v) { return v.price > 0; });
      var included = shock.values.filter(function (v) { return !v.price; });
      ss.appendChild(el("p", "mtkb__no", stepLabel()));
      ss.appendChild(el("h3", null, "Pick your shocks"));
      ss.appendChild(el("p", "mtkb__hint", "Same springs whichever you pick. The shock sets the ride" + (anyPriced ? " and the price." : ".")));
      var cards = el("div", "mtkb__cards");
      shock.values.forEach(function (v) {
        var b = el("button", "mtkb__card");
        b.type = "button";
        b.setAttribute("aria-pressed", "false");
        var top = el("span", "mtkb__cardtop");
        top.appendChild(el("span", "mtkb__cardname", v.label));
        var amtEl = el("span", "mtkb__cardamt", v.price ? "+" + money(v.price) : "Included");
        v.__amtEl = amtEl;
        top.appendChild(amtEl);
        b.appendChild(top);
        var why = shockWhy(v.label);
        if (why) b.appendChild(el("span", "mtkb__cardwhy", why));
        b.addEventListener("click", function () {
          cards.querySelectorAll("button").forEach(function (x) { x.setAttribute("aria-pressed", "false"); });
          b.setAttribute("aria-pressed", "true");
          shockNow = v;
          setSelect(shock.sel, v.value);
          ss.classList.remove("mtkb__field--missing");
          apply();
        });
        cards.appendChild(b);
        if (included.length === 1 && v === included[0]) { b.setAttribute("aria-pressed", "true"); shockNow = v; }
      });
      ss.appendChild(cards);
      root.appendChild(ss);
      if (shockNow) setSelect(shock.sel, shockNow.value);
    }

    /* the truck — these start blank and must be answered */
    if (truck.length) {
      var s2 = el("div", "mtkb__step");
      s2.appendChild(el("p", "mtkb__no", stepLabel()));
      s2.appendChild(el("h3", null, "Tell us about your truck"));
      s2.appendChild(el("p", "mtkb__hint", "We pick the springs off these answers. Not sure? Ring us on 02 8747 0325."));
      var TITLES = { front: "What's on the front?", engine: "Which engine?", rear: "What do you carry in the back?" };
      truck.forEach(function (g) {
        var f = el("div", "mtkb__field");
        // one question of this kind: friendly title; more than one (e.g. a coil per engine): the kit's own label
        var generic = g.kind !== "vehicle" && kindCount[g.kind] === 1;
        var lab = el("label", null, (generic ? TITLES[g.kind] : tidy(g.label)) + " ");
        var sub = null;
        if (g.kind === "rear") sub = g.values.some(function (v) { return /linear|variable/i.test(v.label); }) ? ADVICE_REAR_RATE : ADVICE.rear;
        else if (g.kind === "front" || g.kind === "engine") sub = ADVICE[g.kind];
        else if (g.kind === "vehicle" && /brake hose/i.test(g.label)) sub = ADVICE_BRAKE_HOSE;
        if (sub) lab.appendChild(el("span", "mtkb__sub", sub));
        var sel = el("select");
        sel.appendChild(new Option("-- Please choose --", ""));
        var hasNoAcc = g.values.some(function (v) { return /^no\b/i.test(v.label); });
        g.values.forEach(function (v) {
          if (g.kind === "front" && hasNoAcc && /^none$/i.test(v.label)) return;   // bare "None" next to "No Accessories"
          var op = new Option(v.label + (v.price ? " (+" + money(v.price) + ")" : ""), v.value);
          v.__opt = op;
          sel.appendChild(op);
        });
        sel.value = g.sel.value || "";
        if (sel.selectedIndex < 0) sel.value = "";
        sel.addEventListener("change", function () {
          setSelect(g.sel, sel.value);
          f.classList.toggle("mtkb__field--missing", !sel.value);
          apply();
        });
        lab.setAttribute("for", "mtkb_" + g.sel.id);
        sel.id = "mtkb_" + g.sel.id;
        f.appendChild(lab); f.appendChild(sel);
        s2.appendChild(f);
        truckSelects.push({ g: g, sel: sel, field: f });
      });
      root.appendChild(s2);
    }

    /* finish the job — extras, all unticked */
    var s3 = el("div", "mtkb__step");
    s3.appendChild(el("p", "mtkb__no", ""));
    s3.appendChild(el("h3", null, "Finish the job"));
    var hint3 = el("p", "mtkb__hint", "");
    s3.appendChild(hint3);
    var addonBox = el("div", "mtkb__opts");
    s3.appendChild(addonBox);
    if (addons.length) { s3.firstChild.textContent = stepLabel(); root.appendChild(s3); }

    /* anything we didn't recognise stays as a plain dropdown so nothing is lost */
    if (others.length) {
      var so = el("div", "mtkb__step");
      so.appendChild(el("h3", null, "Other options"));
      others.forEach(function (g) {
        var f = el("div", "mtkb__field");
        var lab = el("label", null, tidy(g.label));
        var sel = el("select");
        sel.appendChild(new Option("-- Please choose --", ""));
        g.values.forEach(function (v) { sel.appendChild(new Option(v.raw, v.value)); });
        sel.value = g.sel.value;
        if (sel.selectedIndex < 0) sel.value = "";
        sel.addEventListener("change", function () { setSelect(g.sel, sel.value); f.classList.toggle("mtkb__field--missing", !sel.value); apply(); });
        f.appendChild(lab); f.appendChild(sel);
        so.appendChild(f);
        if (g.required) truckSelects.push({ g: g, sel: sel, field: f });
      });
      root.appendChild(so);
    }

    /* total */
    var foot = el("div", "mtkb__foot");
    var sumRow = el("div", "mtkb__sumrow");
    var left = el("div");
    left.appendChild(el("div", "mtkb__lab", "Your kit"));
    var sumEl = el("div", "mtkb__sum", "—");
    left.appendChild(sumEl);
    var cnt = el("div", "mtkb__lab", "Kit only");
    sumRow.appendChild(left); sumRow.appendChild(cnt);
    foot.appendChild(sumRow);
    var msg = el("p", "mtkb__msg", "");
    foot.appendChild(msg);
    root.appendChild(foot);

    var state = {};

    function renderAddons() {
      addonBox.innerHTML = "";

      var ranked = { req: [], rec: [], opt: [] };
      addons.forEach(function (g) {
        var key = addonKey(g.label);
        var adv = key ? ADVICE[key] : null;
        var band = adv ? ((heightNow || 2) >= 3 ? adv.g3 : adv.g2) : "opt";
        ranked[band].push({ g: g, adv: adv, band: band });
      });

      if (heightNow && ranked.req.length) {
        hint3.textContent = "At " + heightNow + " inch the extras marked Needed stop being a suggestion. Tick what you want — nothing is added unless you tick it.";
      } else if (heightNow && (heightNow || 2) < 3 && addons.some(function (g) { var k = addonKey(g.label); return k && ADVICE[k] && ADVICE[k].g3 === "req"; })) {
        hint3.textContent = "At " + heightNow + " inch you can get away without the extras that become a must at 3 inch. Tick what you want — nothing is added unless you tick it.";
      } else {
        hint3.textContent = "Tick what you want — nothing is added unless you tick it. Not sure? Ring us on 02 8747 0325.";
      }

      ["req", "rec", "opt"].forEach(function (band) {
        ranked[band].forEach(function (item) {
          var g = item.g, adv = item.adv;
          var ys = yesValues(g);
          if (!ys.length) return;

          var row = el("div", "mtkb__opt");
          var cb = document.createElement("input");
          cb.type = "checkbox";
          cb.id = "mtkb_cb_" + g.sel.id;
          cb.checked = !!state[g.sel.id];

          var body = el("div", "mtkb__body");
          var lab = el("label", null, tidy(g.label.replace(/^add\s+/i, "").replace(/\s*\*$/, "")));
          lab.setAttribute("for", cb.id);
          body.appendChild(lab);

          // one yes answer: show what it is (the brand, the exact part) under the name
          if (ys.length === 1) {
            var detail = extraDetail(ys[0].label, g.label);
            if (detail) body.appendChild(el("p", "mtkb__detail", detail));
          }

          var whyTxt = adv ? (((heightNow || 2) >= 3 ? adv.why3 : adv.why2) || adv.why) : "";
          if (whyTxt && /tough ?dog/i.test(pageTitle())) whyTxt = whyTxt.replace(/Dobinsons recommend/g, "We recommend");
          if (whyTxt) body.appendChild(el("p", "mtkb__why", whyTxt));

          var pill = el("span", "mtkb__pill mtkb__pill--" + band,
            band === "req" ? "Needed at " + heightNow + " inch" : (band === "rec" ? "Recommended" : "Optional"));
          body.appendChild(pill);

          if (ys.length > 1) {
            var wrapSel = el("div", "mtkb__chooser");
            var chooser = el("select");
            ys.forEach(function (v, i) { var cop = new Option(choiceLabel(v.label) + " — " + money(v.price), String(i)); v.__chOpt = cop; chooser.appendChild(cop); });
            chooser.value = String(state[g.sel.id + "_pick"] || 0);
            chooser.addEventListener("change", function () {
              state[g.sel.id + "_pick"] = +chooser.value;
              apply();
            });
            wrapSel.appendChild(chooser);
            body.appendChild(wrapSel);
          }

          var amt = el("div", "mtkb__amt", money(ys[state[g.sel.id + "_pick"] || 0].price));
          g.__amtEl = amt;

          cb.addEventListener("change", function () {
            state[g.sel.id] = cb.checked;
            apply();
          });

          row.appendChild(cb); row.appendChild(body); row.appendChild(amt);
          addonBox.appendChild(row);
        });
      });
      apply();
    }

    function apply() {
      // add-on answers go into their selects first (the variant ones feed the variant lookup)
      addons.forEach(function (g) {
        var ys = yesValues(g), no = noThanksValue(g);
        var pick = ys[state[g.sel.id + "_pick"] || 0];
        if (state[g.sel.id] && pick) setSelect(g.sel, pick.value);
        else if (no) setSelect(g.sel, no);
      });
      if (VG) { VG.refresh(); VG.sync(); }
      var total = VG ? VG.price() : (basePrice || 0), n = 0;
      if (shockNow && !shockNow.virtual) total += shockNow.price;
      truckSelects.forEach(function (t) {
        if (t.g.virtual) return;
        var v = t.g.values.filter(function (x) { return x.value === t.sel.value; })[0];
        if (v) total += v.price;
      });
      addons.forEach(function (g) {
        var ys = yesValues(g);
        var pick = ys[state[g.sel.id + "_pick"] || 0];
        if (g.__amtEl && pick) g.__amtEl.textContent = money(pick.price);
        if (state[g.sel.id] && pick) { if (!pick.virtual) total += pick.price; n++; }
      });
      sumEl.textContent = (VG || basePrice) ? money(total) : "—";
      cnt.textContent = n === 0 ? "Kit only" : "Kit + " + n + (n === 1 ? " extra" : " extras");
      var left = pending().length;
      msg.className = "mtkb__msg";
      msg.textContent = left ? left + (left === 1 ? " question" : " questions") + " above still to answer before adding to cart." : "";
    }

    // every question still unanswered: the truck selects, plus the shock cards if none is picked
    function pending() {
      var list = truckSelects.filter(function (t) { return !t.sel.value; });
      if (shock && !shockNow && shockStep) list.unshift({ field: shockStep, sel: null });
      return list;
    }

    // stop an incomplete order going through while APO's own messages are hidden.
    // APO handles the add-to-cart click high up in the page and then submits the form
    // itself (no submit event), so the check sits on the window AND on form.submit().
    var form = (container || anchor).closest("form");
    function showMissing(missing) {
      missing.forEach(function (t) { t.field.classList.add("mtkb__field--missing"); });
      msg.className = "mtkb__msg mtkb__msg--bad";
      msg.textContent = "Please answer the " + (missing.length === 1 ? "question" : missing.length + " questions") + " marked in red first.";
      if (missing[0].sel) missing[0].sel.focus();
      missing[0].field.scrollIntoView({ behavior: "smooth", block: "center" });
    }
    function stop(e, missing) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      showMissing(missing);
    }
    function guardClick(e) {
      if (!form) return;
      var t = e.target && e.target.closest ? e.target.closest('button[type="submit"], [name="add"], .mw-apo-add-to-cart, .shopify-payment-button') : null;
      if (!t || !form.contains(t)) return;
      var missing = pending();
      if (missing.length) stop(e, missing);
    }
    function guardSubmit(e) {
      var missing = pending();
      if (missing.length) stop(e, missing);
    }
    if (form) {
      window.addEventListener("click", guardClick, true);
      form.addEventListener("submit", guardSubmit, true);
      form.submit = function () {
        var missing = pending();
        if (missing.length) { showMissing(missing); return; }
        return window.HTMLFormElement.prototype.submit.call(form);
      };
    }

    var at = container || anchor;
    at.parentNode.insertBefore(root, at);
    if (container) container.classList.add("mtkb-hidden");
    if (VG) variantPickers().forEach(function (n) { n.classList.add("mtkb-hidden"); });
    window.__mtkbTeardown = function () {
      window.removeEventListener("click", guardClick, true);
      if (form) { form.removeEventListener("submit", guardSubmit, true); try { delete form.submit; } catch (e) {} }
      if (root.parentNode) root.parentNode.removeChild(root);
      if (container) container.classList.remove("mtkb-hidden");
      window.__mtkbTeardown = null;
    };
    renderAddons();

    fetch("/products/" + HANDLE + ".js", { credentials: "same-origin" })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (p) { basePrice = (p.price || 0) / 100; apply(); })
      .catch(function () {
        var mp = metaPrice();
        if (mp) { basePrice = mp; apply(); }   // otherwise the total just stays as a dash
      });

    return true;
  }

  /* --- styles ----------------------------------------------------- */

  var css = ""
    + ".mtkb-hidden{display:none!important}"
    + ".mtkb{font-family:inherit;margin:0 0 18px}"
    + ".mtkb__step{border-top:1px solid #d9ddcb;padding:16px 0 2px}"
    + ".mtkb__step:first-child{border-top:0;padding-top:0}"
    + ".mtkb__no{font-size:11px;font-weight:700;letter-spacing:.13em;text-transform:uppercase;color:#5f6d0e;margin:0 0 2px}"
    + ".mtkb h3{font-size:19px;text-transform:uppercase;letter-spacing:.02em;margin:0 0 3px}"
    + ".mtkb__hint{margin:0 0 11px;font-size:13px;color:#5e6554;line-height:1.5}"
    + ".mtkb__seg{display:flex;gap:8px}"
    + ".mtkb__seg button{flex:1 1 0;min-height:54px;font:inherit;font-size:19px;font-weight:700;text-transform:uppercase;background:#fff;color:#5e6554;border:1px solid #d9ddcb;border-radius:3px;cursor:pointer}"
    + ".mtkb__seg button[aria-pressed=\"true\"]{background:#1b1f17;color:#fff;border-color:#1b1f17}"
    + ".mtkb__cards{display:flex;flex-direction:column;gap:8px}"
    + ".mtkb__card{display:block;width:100%;text-align:left;font:inherit;text-transform:none;letter-spacing:0;line-height:1.3;background:#fff;color:#1b1f17;border:1px solid #d9ddcb;border-radius:3px;padding:10px 12px;cursor:pointer}"
    + ".mtkb__card[aria-pressed=\"true\"]{border:2px solid #1b1f17;background:#f6f7f1;padding:9px 11px}"
    + ".mtkb__cardtop{display:flex;justify-content:space-between;gap:10px;align-items:baseline}"
    + ".mtkb__cardname{font-size:15px;font-weight:700;color:#111}"
    + ".mtkb__cardamt{font-size:15px;font-weight:700;white-space:nowrap;font-variant-numeric:tabular-nums;color:#111}"
    + ".mtkb__cardwhy{display:block;margin-top:3px;font-size:12.5px;color:#6b7160;line-height:1.5;font-weight:400}"
    + ".mtkb__field{margin-bottom:13px}"
    + ".mtkb__field label{display:block;font-size:13px;font-weight:600;margin-bottom:4px}"
    + ".mtkb__sub{font-weight:400;color:#5e6554;font-size:12px}"
    + ".mtkb__field select{width:100%;max-width:100%;min-height:46px;font:inherit;font-size:14px;padding:9px 11px;background:#fff;color:#1b1f17;border:1px solid #d9ddcb;border-radius:3px}"
    + ".mtkb__field--missing select{border:2px solid #b3261e;background:#fdf3f2}"
    + ".mtkb__step.mtkb__field--missing .mtkb__card{border-color:#b3261e;background:#fdf3f2}"
    + ".mtkb__opt{display:flex;gap:11px;align-items:flex-start;padding:12px 0;border-top:1px solid #e6e9dc}"
    + ".mtkb__opt:first-child{border-top:0}"
    + ".mtkb__opt input[type=checkbox]{width:22px;height:22px;flex:0 0 auto;margin:2px 0 0;accent-color:#a3b50c}"
    + ".mtkb__body{flex:1 1 auto;min-width:0}"
    + ".mtkb__body label{display:block;font-size:14.5px;font-weight:600;line-height:1.35;cursor:pointer}"
    + ".mtkb__detail{margin:2px 0 0;font-size:13px;color:#2b2f26;font-weight:600;line-height:1.4}"
    + ".mtkb__why{margin:3px 0 0;font-size:12.5px;color:#5e6554;line-height:1.5}"
    + ".mtkb__pill{display:inline-block;font-size:10px;font-weight:700;letter-spacing:.09em;text-transform:uppercase;border-radius:2px;padding:3px 7px;margin-top:6px}"
    + ".mtkb__pill--req{background:#f8ece6;color:#8c3b1f}"
    + ".mtkb__pill--rec{background:#edf1dc;color:#45550f}"
    + ".mtkb__pill--opt{border:1px solid #d9ddcb;color:#5e6554}"
    + ".mtkb__chooser{margin-top:7px}"
    + ".mtkb__chooser select{width:100%;min-height:42px;font:inherit;font-size:13px;padding:7px 9px;background:#fff;border:1px solid #d9ddcb;border-radius:3px}"
    + ".mtkb__amt{font-size:18px;font-weight:700;white-space:nowrap;font-variant-numeric:tabular-nums}"
    + ".mtkb__foot{border-top:2px solid #1b1f17;margin-top:16px;padding-top:13px}"
    + ".mtkb__sumrow{display:flex;flex-wrap:wrap;gap:8px;align-items:baseline;justify-content:space-between}"
    + ".mtkb__lab{font-size:11.5px;font-weight:700;letter-spacing:.09em;text-transform:uppercase;color:#5e6554}"
    + ".mtkb__sum{font-size:33px;font-weight:700;line-height:1;font-variant-numeric:tabular-nums}"
    + ".mtkb__msg{margin:9px 0 0;font-size:13px;color:#5e6554;min-height:1.2em}"
    + ".mtkb__msg--bad{color:#b3261e;font-weight:600}"
    /* headings and questions darker and bolder than the helper text under them */
    + ".mtkb h3{color:#111!important;font-weight:800!important}"
    + ".mtkb__field>label,.mtkb__body>label{color:#111!important;font-weight:700!important;font-size:15px!important}"
    + ".mtkb__sub,.mtkb__why,.mtkb__hint{color:#6b7160!important;font-weight:400!important}"
    + ".mtkb__field>label .mtkb__sub{display:block;font-size:12.5px!important;margin-top:1px}";

  function injectCss() {
    if (document.getElementById("mtkb-css")) return;
    var s = document.createElement("style");
    s.id = "mtkb-css";
    s.textContent = css;
    document.head.appendChild(s);
  }

  /* --- wait for APO, then build ------------------------------------ */

  var tries = 0, vtries = 0, productTried = false;
  function attempt() {
    // v6: Tough Dog kits load the product first; with more than one variant they run in variant mode.
    if (!productTried && isToughDogKit()) {
      productTried = true;
      fetch("/products/" + HANDLE + ".js", { credentials: "same-origin" })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (p) { PRODUCT = p; })
        .catch(function () {})
        .then(attempt);
      return;
    }
    if (PRODUCT && PRODUCT.variants && PRODUCT.variants.length > 1 && isToughDogKit()) {
      if (window.__mtKitBuilder) return;
      var st = apoState();
      if (st === "wait" && ++vtries < 32) { setTimeout(attempt, 250); return; }
      var c0 = st === "yes" ? document.querySelector(".mw-apo-container") : null;
      window.__mtKitBuilder = true;
      try {
        injectCss();
        VG = makeVariantGroups(PRODUCT);
        if (!VG || !VG.groups.length) throw new Error("no variant questions");
        var anchor = c0 || addToCartAnchor();
        if (!anchor) throw new Error("no place for the builder");
        if (!build(c0, VG.groups, anchor)) throw new Error("build failed");
        if (!c0) watchLateApo();
      } catch (e) {
        standDown(e);
      }
      return;
    }
    var c = document.querySelector(".mw-apo-container");
    if (c && c.querySelector(".mw-option select")) {
      if (!eligible()) return;
      window.__mtKitBuilder = true;
      try {
        injectCss();
        if (!build(c)) c.classList.remove("mtkb-hidden");
      } catch (e) {
        c.classList.remove("mtkb-hidden");
        if (window.console) console.log("[mtkb] stood down:", e);
      }
      return;
    }
    if (++tries < 60) setTimeout(attempt, 250);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", attempt);
  else attempt();
})();
